import styled from 'styled-components';
import { S_FlexBox } from '../../../style/FlexBox.style';

export const S_TitleWrapper = styled(S_FlexBox)`
  width: 100%;
  margin: 30px 0;

  font-weight: 500;
  font-size: 1.2rem;

  color: #464646;
`;
